<template>
  <div>
    <div v-if="$route.meta.showPaymentInfo" class="smaller-container-wrapper">
      <p class="text-dark text-center font-weight-bolder m-0 payment-info">
        {{
          $t('message.eCommerceV2.finance.intro.msg', {
            terms: `${paymentTerm} ${$t('message.eCommerceV2.paymentCalculator.months')}`,
            period: $t(`message.eCommerceV2.paymentCalculator.${paymentPeriod}Period2`),
            paymentAmount: $n(paymentAmount, 'currencyDollars', languageCode),
          })
        }}
      </p>
    </div>
    <MobialisProgressBar
      v-if="progressBarData.numberOfSteps && progressBarData.navInfo"
      class="pt-2 pt-sm-3 pb-4 pb-sm-4 smaller-container-wrapper"
      :class="{ 'mt-0 pt-0': $route.meta.showPaymentInfo }"
      :numberOfSteps="progressBarData.numberOfSteps"
      :navInfo="progressBarData.navInfo"
    >
    </MobialisProgressBar>
    <router-view :class="{ 'with-top-heading': $route.meta.showPaymentInfo }"></router-view>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'EcommerceV2Wrapper',
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      paymentAmount: 'paymentCalculator/currentPaymentAmount',
      paymentTerm: 'paymentCalculator/currentPaymentTerm',
    }),
    ...mapState('paymentCalculator', ['paymentPeriod', 'paymentMethod']),
    progressBarData() {
      return {
        numberOfSteps: this.getNumberOfStepsForProgress(),
        navInfo: this.$route.meta.navInfo,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-info {
  line-height: 13px;
}
</style>
